module.exports = __webpack_public_path__ + "img/phone.58736bcc.svg";